<template>
  <div class="row">
    <div class="col-md-3 mb-2">
      <select
        class="form-control"
        v-model="meta.per_page"
        @change="loadPerPage"
      >
        <option value="5">
          Tampilkan tiap 5 data
        </option>
        <option value="10">
          Tampilkan tiap 10 data
        </option>
        <option value="25">
          Tampilkan tiap 25 data
        </option>
        <option value="50">
          Tampilkan tiap 50 data
        </option>
        <option value="100">
          Tampilkan tiap 100 data
        </option>
      </select>
    </div>

    <div class="col-md-3 offset-md-6">
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          @input="search"
          placeholder="Cari Nama Penduduk/NIK/Username/Email/No HP"
        >
        <div class="input-group-append">
          <button
            class="btn btn-primary"
            type="button"
          >
            <i class="fa fa-search" />
          </button>
        </div>
      </div>
    </div>
      
    <div class="col-md-12">
      <div class="table-responsive">
        <b-table
          striped
          hover
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          small
          show-empty
        >
          <template v-slot:cell(no)="row">
            {{ (meta.per_page * (meta.current_page-1)) + row.index + 1 }}
          </template>

          <template v-slot:cell(nama_lengkap)="row">
            {{ row.item.nama_lengkap}}
            <span
              v-b-tooltip
              :title="row.item.email"
              style="cursor: pointer"
            >
              <i class="fa fa-info-circle" />
            </span>
          </template>
        </b-table>
      </div>
      <div
        class="overlay-table-loader"
        v-if="loading"
      >
        <b-spinner
          variant="primary"
          label="Text Centered"
        />
      </div>
    </div>
      
    <div class="col-md-6">
      <p>Menampilkan {{ meta.from }} sampai {{ meta.to }} dari {{ meta.total }} data</p>
    </div>
      
    <div class="col-md-6">
      <b-pagination
        v-model="meta.current_page"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        align="right"
        @change="changePage"
        aria-controls="dw-datatable"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        fields: {
            type: Array,
            required: true
        },
        meta: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            default: null
        }
    },
    data() {
        return {
            sortBy: null,
            sortDesc: false
        }
    },
    watch: {
        sortBy(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        sortDesc(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
    methods: {
        loadPerPage(val) {
            this.$emit('per_page', this.meta.per_page)
        },
        changePage(val) {
            this.$emit('pagination', val)
        },
        search: _.debounce(function (e) {
            this.$emit('search', e.target.value)
        }, 500),
    }
}
</script>